import request from '@meitu/saas-editor-ui/es/request';
import { IFetchBackgroundsParams, TFetchBackgroundsResponse } from './index.d';

/**
 * 接口 [背景素材列表↗](/api/v1/material/backgrounds)
 * @docs: https://api-mock.meitu-int.com/project/1289/interface/api/105537
 */
export const fetchBackgrounds = async function (params: IFetchBackgroundsParams) {
    return await request<TFetchBackgroundsResponse>('/seal_pie_internal/material_list.json', {
        method: 'GET',
        params: {
            ...params,
            type: 'pic_background',
        },
    });
};
